import React, { useState } from 'react';
import './WebinarListItem.css';
import plusIcon from '../../Assests/assets/images/Icon_Plus.svg';

function getWebinarDateStyle(status) {
  if(status === 'upcoming-next') {
    return {
    };
  }
  if(status === 'upcoming-future') {
    return {
      'text-align': 'right',
      'font': 'Bold Roman 18px/23px Muli',
      'letter-spacing': '0px',
      'color': '#00AEEF',
      'text-transform':'capitalize',
      'opacity': 1
    };
  }
  if(status === 'completed') {
    return {
    };
  }
}
function getDateNumSessionsContainerStyle(status) {
  if(status === 'upcoming-next') {
    return {
      'background': '#FFBC00 0% 0% no-repeat padding-box'
    };
  }
  if(status === 'upcoming-future') {
    return {
      'background': 'none'
    };
  }
  if(status === 'completed') {
    return {
      'background': '#27AE60 0% 0% no-repeat padding-box'
    };
  }
}
const WebinarListItem = (props) => {
  let name = 'Commerce -6';
  let status = 'completed';
  let dateOfWebinar = 'Sept 05, 2020';
  let noOfSessions = 2;
  console.log(props);
  return (
    <div class="webinar-list-item">
      <span class='webinar-list-item-icon'>
        <img src={plusIcon}/>
      </span>
      <span class='webinar-list-title-container'>
        {props.name}
      </span>
      <div class='date-num-sessions-container'>
        <span class='webinar-date-container' style={getDateNumSessionsContainerStyle(props.status)}>
          <span class='webinar-date' style={getWebinarDateStyle(props.status)}>
            {props.dateOfWebinar}
          </span>
        </span>
        <span class='webinar-num-sessions-container'>
          {props.noOfSessions} Sessions
        </span>
      </div>
    </div>
  )
};
export default WebinarListItem;
